import React, { useState } from 'react';
import { Home } from 'lucide-react';
import '../styles/Modal.css';

function AddHouseholdModal({ isOpen, onClose, onSubmit }) {
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!name.trim()) {
      setError('Household name is required');
      return;
    }

    setIsSubmitting(true);
    try {
      await onSubmit(name.trim());
      setName(''); // Clear form
      onClose();
    } catch (error) {
      setError(error.response?.data?.error || 'Failed to create household');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setName('');
    setError('');
    onClose();
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-container add-household-modal">
        <div className="modal-header">
          <div className="modal-title-wrapper">
            <Home className="modal-icon" size={24} />
            <h3>Add Household</h3>
          </div>
          <button className="modal-close" onClick={handleClose}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {error && <div className="form-error">{error}</div>}
            
            <div className="form-group">
              <label htmlFor="householdName">Household Name</label>
              <div className="input-with-indicator">
                <input
                  type="text"
                  id="householdName"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="e.g., Smith Family, Downtown Apartment"
                  disabled={isSubmitting}
                  autoFocus
                />
                <span className="required-indicator">*</span>
              </div>
              <p className="form-hint">Choose a descriptive name to identify this household</p>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn-secondary"
              onClick={handleClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={isSubmitting || !name.trim()}
            >
              <Home size={18} />
              {isSubmitting ? 'Creating...' : 'Create Household'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddHouseholdModal;
